<script>
export default {
  name: "IconCast",
}
</script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none"><path fill-rule="evenodd" d="M3 3h18c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2h-7v-2h7V5H3v3H1V5c0-1.1.9-2 2-2M1 21v-3c1.66 0 3 1.34 3 3zm0-7v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7m0-2v-2c6.07 0 11 4.92 11 11h-2a9 9 0 0 0-9-9" clip-rule="evenodd"/></svg>
</template>
